import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

/**
 * Trust a blob URL for local iframe/img preview (bytes fetched from the API).
 * Bypass is limited to URLs created via URL.createObjectURL from authenticated API responses.
 */
export function trustBlobResourceUrl(sanitizer: DomSanitizer, url: string): SafeResourceUrl {
  if (!url.startsWith('blob:')) {
    throw new Error('Only blob URLs may be trusted for preview');
  }
  return sanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR S6268 — blob URLs are created locally from authenticated API bytes
}

/**
 * Trust HTML from mammoth docx conversion of server-fetched document bytes.
 * Bypass applies only to HTML produced from documents the user is authorized to view.
 */
export function trustDocxPreviewHtml(sanitizer: DomSanitizer, html: string): SafeHtml {
  return sanitizer.bypassSecurityTrustHtml(html); // NOSONAR S6268 — HTML is mammoth output from authorized document bytes
}

/**
 * Trust an embed URL from a fixed OpenStreetMap template with numeric coordinates.
 * Bypass applies only to https://www.openstreetmap.org/ embed URLs built from validated coordinates.
 */
export function trustMapEmbedUrl(sanitizer: DomSanitizer, url: string): SafeResourceUrl {
  if (!url.startsWith('https://www.openstreetmap.org/')) {
    throw new Error('Only OpenStreetMap embed URLs may be trusted');
  }
  return sanitizer.bypassSecurityTrustResourceUrl(url); // NOSONAR S6268 — URL prefix is validated before trust
}
